<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Operazioni Fase </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Pulsante di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="apriOperazioniFase"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Operazione</span>
      </v-tooltip>

      <!-- Pulsante di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaOperazioniFase" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5" style="overflow-y: auto">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col align="start" cols="12">
            <span style="font-size: 18px">
              Tempo totale: <b>{{ tempo_totale_operazioni }}</b> sec. ({{
                (tempo_totale_operazioni / 60).toFixed(2).replace(",", ".")
              }}
              min.)
            </span>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col class="my-0 py-0" justify="center" cols="12">
            <v-data-table
              :headers="headers_operazioni_fase"
              :items="items_operazioni_fase.filter((e) => e.validita == 1)"
              :item-class="getRowColor"
            >
              <template v-slot:[`item.seleziona_suggerimento`]="{ item }">
                <v-checkbox
                  dense
                  :false-value="0"
                  hide-details
                  :true-value="1"
                  v-model="item.seleziona_suggerimento"
                ></v-checkbox>
              </template>

              <template v-slot:[`item.modifica`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="modificaOperazione(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </template>
                  <span>Modifica</span>
                </v-tooltip>
              </template>

              <!-- Colonna della descrizione -->
              <template v-slot:[`item.des_operazione`]="{ item }">
                <v-text-field
                  dense
                  hide-details
                  v-model="item.des_operazione"
                ></v-text-field>
              </template>

              <!-- Colonna della quantita -->
              <template v-slot:[`item.quantita`]="{ item }">
                <v-text-field
                  dense
                  hide-details
                  v-model="item.quantita"
                ></v-text-field>
              </template>

              <!-- Colonna del tempo -->
              <template v-slot:[`item.tempo`]="{ item }">
                <v-text-field
                  dense
                  hide-details
                  style="display: inline-block; width: 75px"
                  v-model="item.tempo"
                ></v-text-field>

                sec. ({{
                  (
                    (item.tempo != null && item.tempo != "" ? item.tempo : 0) /
                    60
                  )
                    .toFixed(2)
                    .replace(".", ",")
                }}
                min.)
              </template>
              <template v-slot:[`item.elimina`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="eliminaOperazione(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Elimina</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog di selezione operazioni fase -->
    <v-dialog v-model="dialog_seleziona_operazioni" width="90vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Operazioni Standard
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Pulsante dei Modules (fwk) -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="apriModules"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-eye </v-icon>
              </v-btn>
            </template>
            <span>Gestione Operazioni Standard</span>
          </v-tooltip>

          <!-- Pulsante di conferma -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="aggiungiOperazioniFase"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_operazioni = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="descrizione_search"
                  label="Descrizione"
                  @change="filtra"
                >
                  <template slot="append">
                    <v-icon
                      @click="
                        descrizione_search = '';
                        filtra();
                      "
                      color="primary"
                    >
                      mdi-filter-off
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_operazioni_selezionabili"
                  :items="items_operazioni_selezionabili_visualizzate"
                >
                  <template v-slot:[`item.selezionato`]="{ item }">
                    <v-icon
                      @click="selectOperazioneStandard(item)"
                      :color="item.selezionato === 0 ? '' : 'success'"
                      :key="item.selezionato"
                    >
                      {{
                        item.selezionato === 0
                          ? "mdi-checkbox-blank-outline"
                          : "mdi-checkbox-marked"
                      }}
                    </v-icon>
                  </template>

                  <!-- Colonna della descrizione-->
                  <template v-slot:[`item.des`]="{ item }">
                    <v-text-field
                      dense
                      hide-details
                      style="border-radius: 0px"
                      v-model="item.des"
                    ></v-text-field>
                  </template>

                  <!-- Colonna del tempo -->
                  <template v-slot:[`item.val_dbl`]="{ item }">
                    <v-text-field
                      dense
                      hide-details
                      style="border-radius: 0px"
                      v-model="item.val_dbl"
                    ></v-text-field>
                  </template>

                  <!-- Colonna della quantita -->
                  <template v-slot:[`item.val_int`]="{ item }">
                    <v-text-field
                      dense
                      hide-details
                      style="border-radius: 0px"
                      v-model="item.val_int"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica delle operazioni -->
    <v-dialog v-model="dialog_modifica_operazione" width="unset">
      <v-card style="max-width: 900px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Modifica Operazione
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificheOperazione"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Modifiche</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_modifica_operazione = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="4">
                <v-text-field
                  dense
                  hide-details
                  label="Codice"
                  v-model="operazione_sel.cod_operazione"
                ></v-text-field>
              </v-col>
              <v-col class="my-0 py-0" justify="center" cols="4">
                <v-text-field
                  dense
                  hide-details
                  label="Tempo (s)"
                  v-model="operazione_sel.tempo"
                ></v-text-field>
              </v-col>
              <v-col class="my-0 py-0" justify="center" cols="4">
                <v-text-field v-model="operazione_sel.quantita"></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-textarea
                  dense
                  hide-details
                  label="Descrizione"
                  outlined
                  rows="2"
                  style="border-radius: 0px"
                  v-model="operazione_sel.des_operazione"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Window Frame dei Modules -->
    <v-dialog v-model="dialog_modules" max-width="800" min-width="800">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%; overflow-y: hidden">
          <WindowFrame
            class="ma-0 pa-0"
            :component="'fwk'"
            ref="windowframe_modules"
            @chiudi="chiudiModules"
            :input_args="input_args_modules"
            :key="key_modules"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar di avviso -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

class OperazioneFase {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setConsetCampitrolli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "cod_operazione", default_val: "" },
      { nome: "des_operazione", default_val: "" },
      { nome: "id_commessa_operazione", default_val: -1 },
      { nome: "id_tabella", default_val: null },
      { nome: "quantita", default_val: 1 },
      { nome: "seleziona_suggerimento", default_val: 0 },
      { nome: "tempo", default_val: 0 },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  name: "",
  components: { SnackbarQV, WindowFrame },
  props: {
    items_operazioni_fase: {
      type: Array,
      default: () => [],
    },
    checkbox_suggerimento: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tempo_totale_operazioni() {
      let res = 0;

      if (this.items_operazioni_fase) {
        this.items_operazioni_fase
          .filter(
            (o) =>
              o.validita == 1 &&
              (this.checkbox_suggerimento == false ||
                o.seleziona_suggerimento == 1)
          )
          .forEach((o) => {
            res += o.tempo * o.quantita;
          });
      }

      return res;
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      descrizione_search: "",
      input_args_modules: {
        tipo: "OPERAZIONE_FASE_COMMESSA",
        showScadenza: false,
        nome: "Operazioni Fase",
        filter: "",
        landing_page: "/modules",
        nome_col: "Descrizione",
      },
      key_modules: 0,
      operazione_sel: new Object(),

      // Modal
      dialog_modifica_operazione: false,
      dialog_modules: false,
      dialog_seleziona_operazioni: false,
      overlay: false,

      // Array
      headers_operazioni_fase: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
          width: "100px",
        },
        {
          text: "Codice",
          value: "cod_operazione",
          sortable: false,
          width: "150px",
        },
        {
          text: "Descrizione",
          value: "des_operazione",
          sortable: false,
        },
        {
          text: "Tempo",
          value: "tempo",
          sortable: false,
          width: "300px",
        },
        {
          text: "Quantita",
          value: "quantita",
          sortable: false,
          width: "100px",
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
          width: "100px",
        },
      ],
      headers_operazioni_selezionabili: [
        {
          text: "Selezione",
          value: "selezionato",
          sortable: false,
          width: "150px",
        },
        {
          text: "Codice",
          value: "cod",
          sortable: false,
          width: "200px",
        },
        {
          text: "Descrizione",
          value: "des",
          sortable: false,
        },
        {
          text: "Tempo (sec.)",
          value: "val_dbl",
          sortable: false,
          width: "150px",
        },
        {
          text: "Quantita",
          value: "val_int",
          sortable: false,
          width: "100px",
        },
      ],
      items_operazioni_selezionabili: new Array(),
      items_operazioni_selezionabili_visualizzate: new Array(),
    };
  },
  watch: {
    checkbox_suggerimento: {
      immediate: true,
      handler() {
        if (
          this.checkbox_suggerimento === true &&
          this.headers_operazioni_fase.filter(
            (e) => e.value == "checkbox_suggerimento"
          ).length == 0
        ) {
          this.headers_operazioni_fase.unshift({
            text: "Aggiungi Operazione",
            value: "seleziona_suggerimento",
            width: "100px",
          });
        }
      },
    },
  },
  methods: {
    aggiungiOperazioniFase() {
      this.dialog_seleziona_operazioni = false;
      this.items_operazioni_selezionabili_visualizzate.forEach((o) => {
        if (
          o.selezionato == 1 &&
          this.items_operazioni_fase.filter(
            (elem) => elem.id_tabella == o.id_tabella && elem.validita == 1
          ).length == 0
        ) {
          const operazione_tmp = new OperazioneFase(o);
          operazione_tmp.quantita = o.val_int;
          operazione_tmp.tempo = o.val_dbl;
          operazione_tmp.cod_operazione = o.cod;
          operazione_tmp.des_operazione = o.des;
          operazione_tmp.seleziona_suggerimento = 1;
          this.items_operazioni_fase.push(operazione_tmp);
        }
      });
    },
    apriModules() {
      this.dialog_modules = true;
      this.key_modules = this.key_modules === 0 ? 1 : 0;
    },
    apriOperazioniFase() {
      this.descrizione_search = "";

      this.items_operazioni_selezionabili.forEach((o) => {
        o.selezionato = 0;
      });
      this.items_operazioni_selezionabili_visualizzate =
        this.items_operazioni_selezionabili;

      this.dialog_seleziona_operazioni = true;
    },
    chiudiModules() {
      this.dialog_modules = false;

      // Aggiorno le operazioni all'interno della finestra di dialogo.
      this.getOperazioni();
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    eliminaOperazione(arg) {
      const operazione_tmp = JSON.parse(JSON.stringify(arg));
      operazione_tmp.validita = 0;
      this.items_operazioni_fase.forEach((o, index) => {
        if (o.id_tabella == arg.id_tabella) {
          this.$set(this.items_operazioni_fase, index, operazione_tmp);
        }
      });
    },
    filtra() {
      /* Preparo un array temporaneo in cui
       * collezionare le operazioni filtrate */
      let items_operazioni_selezionabili_tmp = [];
      this.items_operazioni_selezionabili.forEach((e) => {
        items_operazioni_selezionabili_tmp.push(Object.assign({}, e));
      });

      //Filtro per descrizione
      if (this.descrizione_search != "") {
        let res = [];
        items_operazioni_selezionabili_tmp.forEach((elem) => {
          if (
            elem.des
              .toLowerCase()
              .includes(this.descrizione_search.toLowerCase())
          ) {
            res.push(Object.assign({}, elem));
          }
        });
        items_operazioni_selezionabili_tmp = [];
        res.forEach((e) => {
          items_operazioni_selezionabili_tmp.push(Object.assign({}, e));
        });
      }

      // Ricostruisco le commesse visualizzate in base agli commesse filtrati.
      this.items_operazioni_selezionabili_visualizzate = Array.from(
        items_operazioni_selezionabili_tmp
      );
    },
    getOperazioni() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "OPERAZIONE_FASE_COMMESSA",
          filter: "validita = 1",
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            res.data.forEach((d) => {
              d.selezionato = 0;
            });

            this.items_operazioni_selezionabili = res.data
              ? res.data
              : new Array();
            this.items_operazioni_selezionabili_visualizzate = res.data
              ? res.data
              : new Array();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getRowColor(arg) {
      // Se non devo mostrare i suggerimenti, ritorno stringa vuota.
      if (!this.checkbox_suggerimento) return "";

      return arg.seleziona_suggerimento == 0
        ? `gestione-operazioni-riga-${arg.colore_suggerimento}`
        : "gestione-operazioni-riga-success";
    },
    modificaOperazione(arg) {
      this.operazione_sel = new OperazioneFase(arg);
      this.dialog_modifica_operazione = true;
    },
    salvaModificheOperazione() {
      this.items_operazioni_fase.forEach((o, index) => {
        if (
          ((o.id_tabella === this.operazione_sel.id_tabella) == o.validita) ==
          1
        ) {
          this.$set(
            this.items_operazioni_fase,
            index,
            new OperazioneFase(this.operazione_sel)
          );
        }
      });

      this.dialog_modifica_operazione = false;
    },
    salvaOperazioniFase() {
      this.$emit(
        "salva_operazioni_fase",
        this.items_operazioni_fase.filter(
          (o) => o.validita == 1 || o.id_commessa_operazione != -1
        )
      );
    },
    selectOperazioneStandard(arg) {
      let arg_tmp = JSON.parse(JSON.stringify(arg));
      arg_tmp.selezionato = arg.selezionato == 0 ? 1 : 0;

      this.items_operazioni_selezionabili_visualizzate.forEach((o, index) => {
        if (o.id_tabella === arg.id_tabella) {
          this.$set(
            this.items_operazioni_selezionabili_visualizzate,
            index,
            arg_tmp
          );
        }
      });
    },
  },
  created() {},
  mounted() {
    this.getOperazioni();
  },
};
</script>
<style>
.gestione-operazioni-riga-orange {
  background-color: #ffcc66;
}
.gestione-operazioni-riga-success {
  background-color: lightgreen;
}
</style>